/**
 * Correo del cliente para evaluar reglas segmentadas (task-1379).
 *
 * Las reglas de productos pueden apuntar a un segmento (top clientes, comuna,
 * lista de correos). El backend necesita el correo para decidir si aplican; sin
 * él solo evalúa las de audiencia "todos".
 *
 * El logueado lo tiene en localStorage `user`, pero el invitado no: el suyo lo
 * escribe en el checkout y queda en `checkoutData.user_order.email`. Mirar solo
 * `user` dejaba al invitado sin las reglas que sí le aplican, y despues la orden
 * (que evalúa por correo) le daba un total distinto al que vio.
 */
const leerJson = (key) => {
  if (typeof localStorage === 'undefined') return null;
  try {
    return JSON.parse(localStorage.getItem(key) || 'null');
  } catch {
    return null;
  }
};

const limpiar = (email) => {
  const valor = typeof email === 'string' ? email.trim() : '';
  return valor.includes('@') ? valor : null;
};

/**
 * @param {object|null} user Usuario del estado global, si lo hay.
 * @returns {string|null}
 */
export const getCustomerEmail = (user = null) => {
  if (typeof window === 'undefined') return null;

  return (
    limpiar(leerJson('user')?.email) ||
    limpiar(user?.email) ||
    limpiar(leerJson('checkoutData')?.user_order?.email) ||
    null
  );
};

export default getCustomerEmail;
